import * as actionTypes from '../Actions/ActionTypes';
import { updateObject } from '../../Helpers/Utility';

const initialState = {
    selectedApp: null,
    allComponent:null,
    selectedComponent:null,
    selectedEnvironment:null,
    selectedConfiguration:null,
    selectedConfigurationForBulkCopy:[],
    configFail:null,
    attributeList:null
}

const selectedApp = (state, action) => {
    return updateObject(state, {
        selectedApp: action.selectedApp,
        selectedComponent: null
        // allcomponent: action.allcomponent,
    });
};
const selectedComponent = (state, action) => {
    return updateObject(state, {
        selectedComponent: action.selectedComponent,
        // allcomponent: action.allcomponent,
    });
};

const allComponent = (state, action) => {
    return updateObject(state, {
        allComponent: action.allComponent,
    });
};

const selectedEnvironment = (state, action) => {
    return updateObject(state, {
        selectedEnvironment: action.selectedEnvironment,
    });
};

const selectedConfiguration = (state, action) => {
    return updateObject(state, {
        selectedConfiguration: action.selectedConfiguration,
    });
};

const selectedConfigurationForBulkCopy = (state, action) => {
    // console.log("selectedConfigurationForBulkCopy");
    // console.log(action.selectedConfigurationForBulkCopy);
    return updateObject(state, {
        selectedConfigurationForBulkCopy: action.selectedConfigurationForBulkCopy,
    });
    
};

//Attribute List
const attributeList = (state, action) => {
    return updateObject(state, {
        attributeList: action.attributeList,
    });
};


const authLogout = (state, action) => {
    // console.log("Reducer AuthLogout");
    return updateObject(state, { selectedApp: null, allComponent: null, selectedComponent: null, selectedEnvironment: null,selectedConfiguration:null,selectedConfigurationForBulkCopy:[],attributeList:null });
};

const configFail = (state, action) => {
    // console.log("Reducer AuthLogout");
    return updateObject(state, {configFail:action});
}; 
const reducer = (state = initialState, action) => {
    // console.log("Reducer Called: " + action.type);
    switch (action.type) {
        case actionTypes.GET_ALL_COMPONENT: return allComponent(state, action);
        case actionTypes.SELECTED_APP: return selectedApp(state, action);
        case actionTypes.SELECTED_COMPONENT: return selectedComponent(state, action);
        case actionTypes.SELECTED_ENVIRONMENT: return selectedEnvironment(state, action);
        case actionTypes.SELECTED_CONFIGURATION:return selectedConfiguration(state, action);
        case actionTypes.SELECTED_CONFIGURATION_FOR_BULKCOPY:return selectedConfigurationForBulkCopy(state, action);
        case actionTypes.ATTRIBUTE_LIST:return attributeList(state, action);
        case actionTypes.AUTH_LOGOUT: return authLogout(state, action);
        case actionTypes.CONFIG_FAIL: return configFail(state, action);
        default:
            return state;
    }
};

export default reducer;
